export interface LineItemAssignment {
  [lineItemId: string]: string | undefined;
}

type AwardableQuoteItem = {
  demandRequestItemId?: string | null;
  isAwardable?: boolean | null;
};

type AwardingCase = {
  id?: string;
  quote?: unknown;
};

export interface LineItemAwardingImpact {
  assignedAwardableLineItemsCount: number;
  dismissedAwardableLineItemsCount: number;
}

const hasAwardableQuoteItems = (
  quote: unknown,
): quote is {
  lineItems?: readonly AwardableQuoteItem[] | null;
} => {
  return typeof quote === 'object' && quote !== null && 'lineItems' in quote;
};

export const getLineItemAwardingImpact = (
  assignments: LineItemAssignment | undefined,
  awardingCases: readonly AwardingCase[],
  alreadyAwardedLineItemIds: ReadonlySet<string> = new Set(),
  selectedCaseIds?: ReadonlySet<string>,
): LineItemAwardingImpact => {
  if (!assignments) {
    return {
      assignedAwardableLineItemsCount: 0,
      dismissedAwardableLineItemsCount: 0,
    };
  }

  const awardableLineItemIds = new Set<string>();

  awardingCases.forEach((awardingCase) => {
    if (selectedCaseIds && awardingCase.id && !selectedCaseIds.has(awardingCase.id)) {
      return;
    }

    if (!hasAwardableQuoteItems(awardingCase.quote)) {
      return;
    }

    awardingCase.quote.lineItems?.forEach((quoteItem) => {
      if (quoteItem.isAwardable && quoteItem.demandRequestItemId) {
        awardableLineItemIds.add(quoteItem.demandRequestItemId);
      }
    });
  });

  let assignedAwardableLineItemsCount = 0;
  let dismissedAwardableLineItemsCount = 0;

  awardableLineItemIds.forEach((lineItemId) => {
    if (assignments[lineItemId]) {
      assignedAwardableLineItemsCount += 1;
      return;
    }

    if (alreadyAwardedLineItemIds.has(lineItemId)) {
      return;
    }

    dismissedAwardableLineItemsCount += 1;
  });

  return {
    assignedAwardableLineItemsCount,
    dismissedAwardableLineItemsCount,
  };
};
